export class CentralStationContactAllergyConditionDto {
    AllergyCode: string;
    AllergyDescription: string;
    Comment: string;
}